import { useMutation } from "@tanstack/vue-query";

import KiliApi from "@/data/api/kili/kili-api";
import { PasswordRecoveryMutationKeys } from "@/data/api/kili/password-recovery/password-recovery-query-keys";

export type TCreatePasswordCommand = {
  email: string;
  password: string;
  token: string;
};

export function useCreatePasswordMutation() {
  return useMutation({
    mutationKey: PasswordRecoveryMutationKeys.createPassword(),
    mutationFn: async (body: TCreatePasswordCommand) => {
      return await KiliApi.createPassword(
        {
          password: body.password,
          token: body.token,
        },
        {
          params: {
            email: body.email,
          },
        },
      );
    },
  });
}
